import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import ImportButton from './ImportButton';

export interface CustomerServicesSyncDialogProps
  extends RouteComponentProps<{ id: string }> {}

function CustomerServicesSyncDialog(props: CustomerServicesSyncDialogProps) {
  const customerId = +props.match.params.id;

  function handleClose() {
    props.history.goBack();
  }

  return (
    <Dialog onClose={handleClose} open={true}>
      <DialogTitle>Asiakkaan hintojen päivitys</DialogTitle>

      <DialogContent>
        <Typography paragraph>
          Hintojen päivitys tehdään massana järjestelmän ulkopuolella
          taulukkolaskentaohjelmassa, esimerkiksi Excelissä.
        </Typography>

        <Typography paragraph>
          Tuo hintatiedot csv:stä: <b>Ensimmäisessä</b> sarakkeessa tulee olla
          tuotteen koodi (esim: "P1000") ja <b>kolmannessa</b> sarakkeessa hinta
          (esim: "345.12").
        </Typography>

        <Typography paragraph>
          <b>Huom:</b> tiedoston hinnat korvaavat aikaisemmat kokonaan. Jos
          tiedostosta puuttuu jokin tuote jolle asiakkaalla aikaisemmin on ollut
          hinta, poistetaan se ja käytetään oletushintaa ko. tuotteelle.
        </Typography>

        <ImportButton customerId={customerId} />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Peruuta</Button>
      </DialogActions>
    </Dialog>
  );
}

export default withRouter(CustomerServicesSyncDialog);
